import { Button } from '@/shared/ui/atoms';
import { useToastStore, type ToastItem } from './toastStore';
import * as s from './Toast.css';

const TYPE_ICONS: Record<NonNullable<ToastItem['type']>, string> = {
  info: '\u2139\uFE0F',
  success: '\u2705',
  warning: '\u26A0\uFE0F',
  error: '\u274C',
};

export function ToastContainer() {
  const toasts = useToastStore((state) => state.toasts);
  const exitingIds = useToastStore((state) => state.exitingIds);
  const startExiting = useToastStore((state) => state.startExiting);
  const removeToast = useToastStore((state) => state.removeToast);

  if (toasts.length === 0) return null;

  const handleDismiss = (id: string) => {
    startExiting(id);
  };

  const handleAnimationEnd = (id: string) => {
    if (exitingIds.has(id)) {
      removeToast(id);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent, toastId: string) => {
    if (e.key === 'Escape' || e.key === 'Enter') {
      handleDismiss(toastId);
    }
  };

  return (
    <div className={s.container} role="region" aria-label="알림">
      {toasts.map((t) => {
        const toastType = t.type ?? 'info';
        return (
          <div
            key={t.id}
            className={`${s.toast} ${s.toastType[toastType]}${exitingIds.has(t.id) ? ` ${s.toastExiting}` : ''}`}
            role={t.type === 'error' ? 'alert' : 'status'}
            tabIndex={0}
            onClick={() => handleDismiss(t.id)}
            onKeyDown={(e) => handleKeyDown(e, t.id)}
            onAnimationEnd={() => handleAnimationEnd(t.id)}
          >
            <span className={s.icon} aria-hidden="true">
              {TYPE_ICONS[toastType]}
            </span>
            <div className={s.content}>
              <div className={s.title}>{t.title}</div>
              {t.body && <div className={s.body}>{t.body}</div>}
              {t.action && (
                <div className={s.actionRow}>
                  <Button
                    type="button"
                    variant="link"
                    size="xs"
                    onClick={(e) => {
                      // 토스트 자체가 클릭으로 닫히므로 버튼 클릭이 두 번 처리되지 않게 여기서 끊는다.
                      e.stopPropagation();
                      t.action?.onClick();
                      handleDismiss(t.id);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
                    }}
                  >
                    {t.action.label}
                  </Button>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
